/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.g2pMessage = (function() {

    /**
     * Properties of a g2pMessage.
     * @exports Ig2pMessage
     * @interface Ig2pMessage
     * @property {string} kind g2pMessage kind
     */

    /**
     * Constructs a new g2pMessage.
     * @exports g2pMessage
     * @classdesc Represents a g2pMessage.
     * @implements Ig2pMessage
     * @constructor
     * @param {Ig2pMessage=} [properties] Properties to set
     */
    function g2pMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * g2pMessage kind.
     * @member {string} kind
     * @memberof g2pMessage
     * @instance
     */
    g2pMessage.prototype.kind = "";

    /**
     * Creates a new g2pMessage instance using the specified properties.
     * @function create
     * @memberof g2pMessage
     * @static
     * @param {Ig2pMessage=} [properties] Properties to set
     * @returns {g2pMessage} g2pMessage instance
     */
    g2pMessage.create = function create(properties) {
        return new g2pMessage(properties);
    };

    /**
     * Encodes the specified g2pMessage message. Does not implicitly {@link g2pMessage.verify|verify} messages.
     * @function encode
     * @memberof g2pMessage
     * @static
     * @param {Ig2pMessage} message g2pMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    g2pMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.kind);
        return writer;
    };

    /**
     * Encodes the specified g2pMessage message, length delimited. Does not implicitly {@link g2pMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof g2pMessage
     * @static
     * @param {Ig2pMessage} message g2pMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    g2pMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a g2pMessage message from the specified reader or buffer.
     * @function decode
     * @memberof g2pMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {g2pMessage} g2pMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    g2pMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.g2pMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.kind = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("kind"))
            throw $util.ProtocolError("missing required 'kind'", { instance: message });
        return message;
    };

    /**
     * Decodes a g2pMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof g2pMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {g2pMessage} g2pMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    g2pMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a g2pMessage message.
     * @function verify
     * @memberof g2pMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    g2pMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.kind))
            return "kind: string expected";
        return null;
    };

    /**
     * Creates a g2pMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof g2pMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {g2pMessage} g2pMessage
     */
    g2pMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.g2pMessage)
            return object;
        var message = new $root.g2pMessage();
        if (object.kind != null)
            message.kind = String(object.kind);
        return message;
    };

    /**
     * Creates a plain object from a g2pMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof g2pMessage
     * @static
     * @param {g2pMessage} message g2pMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    g2pMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.kind = "";
        if (message.kind != null && message.hasOwnProperty("kind"))
            object.kind = message.kind;
        return object;
    };

    /**
     * Converts this g2pMessage to JSON.
     * @function toJSON
     * @memberof g2pMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    g2pMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for g2pMessage
     * @function getTypeUrl
     * @memberof g2pMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    g2pMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/g2pMessage";
    };

    return g2pMessage;
})();

$root.p2gMessage = (function() {

    /**
     * Properties of a p2gMessage.
     * @exports Ip2gMessage
     * @interface Ip2gMessage
     * @property {string} kind p2gMessage kind
     * @property {p2gMessage.Ip2gConfig|null} [config] p2gMessage config
     */

    /**
     * Constructs a new p2gMessage.
     * @exports p2gMessage
     * @classdesc Represents a p2gMessage.
     * @implements Ip2gMessage
     * @constructor
     * @param {Ip2gMessage=} [properties] Properties to set
     */
    function p2gMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * p2gMessage kind.
     * @member {string} kind
     * @memberof p2gMessage
     * @instance
     */
    p2gMessage.prototype.kind = "";

    /**
     * p2gMessage config.
     * @member {p2gMessage.Ip2gConfig|null|undefined} config
     * @memberof p2gMessage
     * @instance
     */
    p2gMessage.prototype.config = null;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * p2gMessage payload.
     * @member {"config"|undefined} payload
     * @memberof p2gMessage
     * @instance
     */
    Object.defineProperty(p2gMessage.prototype, "payload", {
        get: $util.oneOfGetter($oneOfFields = ["config"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new p2gMessage instance using the specified properties.
     * @function create
     * @memberof p2gMessage
     * @static
     * @param {Ip2gMessage=} [properties] Properties to set
     * @returns {p2gMessage} p2gMessage instance
     */
    p2gMessage.create = function create(properties) {
        return new p2gMessage(properties);
    };

    /**
     * Encodes the specified p2gMessage message. Does not implicitly {@link p2gMessage.verify|verify} messages.
     * @function encode
     * @memberof p2gMessage
     * @static
     * @param {Ip2gMessage} message p2gMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    p2gMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.kind);
        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
            $root.p2gMessage.p2gConfig.encode(message.config, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified p2gMessage message, length delimited. Does not implicitly {@link p2gMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof p2gMessage
     * @static
     * @param {Ip2gMessage} message p2gMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    p2gMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a p2gMessage message from the specified reader or buffer.
     * @function decode
     * @memberof p2gMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {p2gMessage} p2gMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    p2gMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.p2gMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.kind = reader.string();
                    break;
                }
            case 2: {
                    message.config = $root.p2gMessage.p2gConfig.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("kind"))
            throw $util.ProtocolError("missing required 'kind'", { instance: message });
        return message;
    };

    /**
     * Decodes a p2gMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof p2gMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {p2gMessage} p2gMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    p2gMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a p2gMessage message.
     * @function verify
     * @memberof p2gMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    p2gMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (!$util.isString(message.kind))
            return "kind: string expected";
        if (message.config != null && message.hasOwnProperty("config")) {
            properties.payload = 1;
            {
                var error = $root.p2gMessage.p2gConfig.verify(message.config);
                if (error)
                    return "config." + error;
            }
        }
        return null;
    };

    /**
     * Creates a p2gMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof p2gMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {p2gMessage} p2gMessage
     */
    p2gMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.p2gMessage)
            return object;
        var message = new $root.p2gMessage();
        if (object.kind != null)
            message.kind = String(object.kind);
        if (object.config != null) {
            if (typeof object.config !== "object")
                throw TypeError(".p2gMessage.config: object expected");
            message.config = $root.p2gMessage.p2gConfig.fromObject(object.config);
        }
        return message;
    };

    /**
     * Creates a plain object from a p2gMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof p2gMessage
     * @static
     * @param {p2gMessage} message p2gMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    p2gMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.kind = "";
        if (message.kind != null && message.hasOwnProperty("kind"))
            object.kind = message.kind;
        if (message.config != null && message.hasOwnProperty("config")) {
            object.config = $root.p2gMessage.p2gConfig.toObject(message.config, options);
            if (options.oneofs)
                object.payload = "config";
        }
        return object;
    };

    /**
     * Converts this p2gMessage to JSON.
     * @function toJSON
     * @memberof p2gMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    p2gMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for p2gMessage
     * @function getTypeUrl
     * @memberof p2gMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    p2gMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/p2gMessage";
    };

    p2gMessage.p2gConfig = (function() {

        /**
         * Properties of a p2gConfig.
         * @memberof p2gMessage
         * @interface Ip2gConfig
         * @property {string} text p2gConfig text
         */

        /**
         * Constructs a new p2gConfig.
         * @memberof p2gMessage
         * @classdesc Represents a p2gConfig.
         * @implements Ip2gConfig
         * @constructor
         * @param {p2gMessage.Ip2gConfig=} [properties] Properties to set
         */
        function p2gConfig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * p2gConfig text.
         * @member {string} text
         * @memberof p2gMessage.p2gConfig
         * @instance
         */
        p2gConfig.prototype.text = "";

        /**
         * Creates a new p2gConfig instance using the specified properties.
         * @function create
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {p2gMessage.Ip2gConfig=} [properties] Properties to set
         * @returns {p2gMessage.p2gConfig} p2gConfig instance
         */
        p2gConfig.create = function create(properties) {
            return new p2gConfig(properties);
        };

        /**
         * Encodes the specified p2gConfig message. Does not implicitly {@link p2gMessage.p2gConfig.verify|verify} messages.
         * @function encode
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {p2gMessage.Ip2gConfig} message p2gConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        p2gConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.text);
            return writer;
        };

        /**
         * Encodes the specified p2gConfig message, length delimited. Does not implicitly {@link p2gMessage.p2gConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {p2gMessage.Ip2gConfig} message p2gConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        p2gConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a p2gConfig message from the specified reader or buffer.
         * @function decode
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {p2gMessage.p2gConfig} p2gConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        p2gConfig.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.p2gMessage.p2gConfig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.text = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("text"))
                throw $util.ProtocolError("missing required 'text'", { instance: message });
            return message;
        };

        /**
         * Decodes a p2gConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {p2gMessage.p2gConfig} p2gConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        p2gConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a p2gConfig message.
         * @function verify
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        p2gConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.text))
                return "text: string expected";
            return null;
        };

        /**
         * Creates a p2gConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {p2gMessage.p2gConfig} p2gConfig
         */
        p2gConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.p2gMessage.p2gConfig)
                return object;
            var message = new $root.p2gMessage.p2gConfig();
            if (object.text != null)
                message.text = String(object.text);
            return message;
        };

        /**
         * Creates a plain object from a p2gConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {p2gMessage.p2gConfig} message p2gConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        p2gConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.text = "";
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            return object;
        };

        /**
         * Converts this p2gConfig to JSON.
         * @function toJSON
         * @memberof p2gMessage.p2gConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        p2gConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for p2gConfig
         * @function getTypeUrl
         * @memberof p2gMessage.p2gConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        p2gConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/p2gMessage.p2gConfig";
        };

        return p2gConfig;
    })();

    return p2gMessage;
})();

module.exports = $root;
